import { useEffect, useMemo, useRef, useState } from 'react';
// Helpers
import { buildScoreboardOverlaySrc } from './fightCardHelpers';
import { resolveSponsorLogoUrl } from 'ui/VideoPlayer/components/StreamOverlay/streamOverlayTemplate';
// Styles
import styles from './ScoreboardOverlay.module.scss';

export type ScoreboardOverlayProps = {
  fighterA?: string | null;
  fighterB?: string | null;
  weightClass?: string | null;
  roundLabel?: string | null;
  timer?: string | null;
  sponsorLogoKey?: string | null;
  templateId?: string | null;
};

const ScoreboardOverlay = ({
  fighterA,
  fighterB,
  weightClass,
  roundLabel,
  timer,
  sponsorLogoKey,
  templateId,
}: ScoreboardOverlayProps) => {
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
  const [loaded, setLoaded] = useState(false);

  const src = useMemo(
    () =>
      buildScoreboardOverlaySrc(
        {
          fighterA,
          fighterB,
          weightClass,
          roundLabel,
          timer,
          sponsorLogoKey,
        },
        templateId ?? undefined
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [templateId]
  );

  useEffect(() => {
    if (!loaded) return;
    iframeRef.current?.contentWindow?.postMessage(
      {
        type: 'scoreboard:update',
        fields: {
          fighterA: fighterA || '',
          fighterB: fighterB || '',
          weightClass: weightClass || '',
          roundLabel: roundLabel || '',
          timer: timer || '',
          sponsorLogoUrl: resolveSponsorLogoUrl(sponsorLogoKey),
        },
      },
      '*'
    );
  }, [
    loaded,
    fighterA,
    fighterB,
    weightClass,
    roundLabel,
    timer,
    sponsorLogoKey,
  ]);

  return (
    <iframe
      ref={iframeRef}
      className={styles.overlayIframe}
      title="Scoreboard overlay"
      src={src}
      onLoad={() => setLoaded(true)}
      scrolling="no"
      aria-hidden
    />
  );
};

export default ScoreboardOverlay;
